import React from 'react';
import * as constants from './constants';
import './OverallScoreBlob.scss';

export default function OverallScoreBlob(props) {
    let scoreValueClass = 'overall-score__blob__value';
    let scoreValue = '';

    switch(props.type) {
        case constants.IN_TEST:
            scoreValue = 'In \n Test';
            break;
        case constants.NOT_TESTED:
            scoreValue = 'Not \n Tested';
            break;
        case constants.DONT_BUY:
            scoreValueClass += ' crux-icons crux-icons-close';
            break;
        default:
            scoreValue = props.score;
    }

    return (
        <span className={`overall-score__blob ${props.type}`}>
            <span className={scoreValueClass}>
                {scoreValue}
            </span>
        </span>
    );
}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/OverallScore/OverallScoreBlob.jsx